export const optionalNumber = (value: number | null) => {
  return Number.isNaN(value) ? undefined : value;
};
